import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { CommunityNotificationSettingsDataObject } from 'models/service';

export const getNotificationSettings = async ({ id }: { id: string }) =>
  apiClient.get<CommunityNotificationSettingsDataObject, ApiClientResponse<CommunityNotificationSettingsDataObject>>(
    routes.community.notifications.get(id),
  );
